import { MedplumClient, ValueSetExpandParams } from "@medplum/core";
import { ValueSetExpansionContains } from "@medplum/fhirtypes";

import { uniqBy } from "lodash";

/**
 * Returns the unique codings from a value set expansion.
 * Based on Medplum's ValueSetAutocomplete component.
 * @param medplum The Medplum client.
 * @param params The value set expansion parameters.
 * @param options The request options.
 * @returns The unique codings, where uniqueness is determined by both the `system` and `code` keys.
 * This means that two codings with the same `code` but different `system` are considered unique, and vice versa.
 */
export async function getValueSetExpansionCodings(
  medplum: MedplumClient,
  params: ValueSetExpandParams,
  options?: RequestInit,
): Promise<ValueSetExpansionContains[]> {
  const valueSet = await medplum.valueSetExpand(params, options);
  const valueSetElements = valueSet.expansion?.contains as ValueSetExpansionContains[];
  return uniqBy(valueSetElements, (element) => `${element.system}-${element.code}`);
}
